import { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

const context = {
    messages: [],
    setMessages: () => {},
    upsertMessages: () => {}
}

export const MessageContext = createContext(context);

const MessageContextProvider = ({ children }) => {
    const [messages, setMessages] = useState([]);

    const upsertMessages = (messagesToUpsert) => {
        const newMessages = [...messages];
        let hasUpdates = false;
        for (const messageToUpsert of messagesToUpsert) {
            const index = newMessages.findIndex(message => message.id === messageToUpsert.id);
            if (index !== -1 && newMessages[index].updated_at !== messageToUpsert.updated_at) {
                newMessages[index] = messageToUpsert;
                hasUpdates = true;
            } else if (index === -1) {
                newMessages.push(messageToUpsert);
                hasUpdates = true;
            }
        }
        if (hasUpdates) {
            setMessages(newMessages);
        }
    }

    const providerValue = useMemo(() => (
        { messages, setMessages, upsertMessages }
    ), [messages, setMessages, upsertMessages]);

    return (
        <MessageContext.Provider value={providerValue}>
            {children}
        </MessageContext.Provider>
    )
}

MessageContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default MessageContextProvider;
